/*
 * api
 */

var axios = require('axios');

var userApi = axios.create({
  baseURL: spat.config.api.endpoint,
  responseType: 'json',
});

var api = {
  token: null,

  setToken(token) {
    this.token = token;
    return this;
  },

  async request(config) {
    // 必ずトークンと language をセット
    var token = this.token;
    config.headers = {
      'Authorization': `Bearer ${this.token}`,
      'X-Language': navigator.language,
    };
    
    try {
      var res = await userApi.request(config);
      return res;
    }
    catch(error) {
      spat.modal.alert(error.response.data.message, 'Error');
      throw error
    }
  },
};

export default api;

